"use strict";
/*
 * Created on 12 08 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductPurchasePriceConverter
 *
 * @author JMe
 */


var ProductPurchasePriceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductPurchasePriceConverter, _DataObjectConverter_);

  function ProductPurchasePriceConverter() {
    _classCallCheck(this, ProductPurchasePriceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPurchasePriceConverter).apply(this, arguments));
  }

  return ProductPurchasePriceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductPurchasePriceConverter = ProductPurchasePriceConverter;